import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { DialogFormState, EditFolderTypes, FolderList } from "../../modal";
import { CardHeader, Container, ListItemButton, Tooltip } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import FolderIcon from "@mui/icons-material/Folder";
import { Stack } from "@mui/material";
import { DeleteFolderIcon } from "../../../../assets/FileRepositoryIcon";
import { RenameFolderIcon } from "../../../../assets/FileRepositoryIcon";
import DialogBoxForm from "../DialogBoxFileRepositoryForm";
import { useFileRepository } from "../../FileRepositoryContext";
import { CircularProgress, Collapse } from "@mui/material";

import { createFolder, fetchFolderList, deleteFolder, EditFolder } from "../../helper";
import DialogBoxComponent from "../../../../components/DialogBoxComponent";
import { useUserContext } from "../../../../context/auth/UserContext";
import { useAccessRights } from "../../../../utils/useAccessRights";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

export const FolderListComponent = () => {
  const {
    selectedFolder,
    setSelectedFolder,
    folderList,
    setFolderList,
    refreshFolderList,
    setRefreshFolderList,
    openedListItems,
    setOpenedListItems,
  } = useFileRepository();

  const fileRepoAccess = useAccessRights("File Repository");

  const { userId, companyProfileID, userAccess } = useUserContext();
  const [loadingFolderList, setLoadingFolderList] = useState<boolean>(true);
  const [folderDetails, setFolderDetails] = useState<any>(null);
  const [dialogState, setDialogState] = useState({
    title: "",
    body: "",
    action: "",
    actionCancel: "",
    openDeleteConfirmationDialog: false,
    openSuccessDialogBox: false,
  });
  const [dialogForm, setDialogForm] = useState<DialogFormState>({
    title: "",
    action: "",
    actionCancel: "",
    data: null,
    openDialogCreate: false,
    openDialogRename: false,
  });

  const hasFetched = useRef(false);

  const organizeFolders = (folders: any[]) => {

    const rootFolders: any[] = [];
    folders.forEach((folder: any) => {
      folder.rowId = folder.folderId;
      if (folder.subFolders && folder.subFolders.length > 0) {
        const isFilesAvailaleInSubFolders = folder.subFolders.some((item: { isFilesAvailable: any; }) => item.isFilesAvailable)
        folder.isFilesAvailable = isFilesAvailaleInSubFolders || folder.isFilesAvailable
        folder.subFolders = folder.subFolders.map((subFolder: any) => ({
          ...folder,
          ...subFolder,
          rowId: subFolder.folderId,
          parentFolderId: folder.folderId,
          subFolders: []
        }));
      }
      // Identify root folders (folders with no parentFolderId)
      if (!folder.parentFolderId) {
        rootFolders.push(folder);
      }

    });


    return rootFolders;

  };

  const handleFetchFolderList = async () => {
    try {
      const res = await fetchFolderList(companyProfileID);
      // console.log("handleFetchFolderList", "res", res);

      let list = await organizeFolders(res);
      // console.log("handleFetchFolderList list", list);

      setFolderList(list);
    } catch (error) {
      // console.log("@@Error:", error);
    } finally {
      setLoadingFolderList(false);
      setRefreshFolderList(false);
    }
  };
  const handleCreateFolder = async (payload: any) => {
    try {
      const res = await createFolder(payload);
      // console.log("handleCreateFolder", "res", res.succeeded);
      if (res.succeeded) {
        // console.log("handleCreateFolder payload", payload);

        handleFetchFolderList();
        setDialogState({
          title: "Success",
          body: `<strong>${payload.folderName}</strong> is created successfully`,
          action: "OK",
          actionCancel: "",
          openDeleteConfirmationDialog: false,
          openSuccessDialogBox: true,
        });
      } else {
        setDialogState({
          title: "Error",
          body: "An error occurred while creating the folder.",
          action: "OK",
          actionCancel: "",
          openDeleteConfirmationDialog: false,
          openSuccessDialogBox: true,
        });
      }
    } catch (error) {
      // console.log("@@Error:", error);
    } finally {
      // setLoadingFolderList(false)
    }
  };
  const handleRenameFolderAPI = async (payload: any) => {
    try {
      const res = await EditFolder(payload);
      // console.log("handleRenameFolderAPI", "res", res.succeeded);
      if (res.succeeded) {
        // console.log("handleRenameFolderAPI payload", payload);

        handleFetchFolderList();
        setDialogState({
          title: "Success",
          body: `<strong>${payload.folderName}</strong> is renamed successfully`,
          action: "OK",
          actionCancel: "",
          openDeleteConfirmationDialog: false,
          openSuccessDialogBox: true,
        });
      } else {
        setDialogState({
          title: "Error",
          body: "An error occurred while renaming the folder.",
          action: "OK",
          actionCancel: "",
          openDeleteConfirmationDialog: false,
          openSuccessDialogBox: true,
        });
      }
    } catch (error) {
      console.log("@@Error:", error);
    } finally {
      setLoadingFolderList(false)
    }
  };

  const handleDeleteFolder = async (folderDetails: any) => {
    try {
      const res = await deleteFolder(folderDetails);
      // console.log("handleDeleteFolder", "res", res.succeeded);
      if (res.succeeded) {
        // console.log("handleDeleteFolder payload", folderDetails);
        handleFetchFolderList();
        setFolderDetails(null);
        setDialogState({
          title: "Success",
          body: "Folder deleted successfully",
          action: "OK",
          actionCancel: "",
          openDeleteConfirmationDialog: false,
          openSuccessDialogBox: true,
        });
      } else {
        setFolderDetails(null);
        setDialogState({
          title: "Error",
          body: "An error occurred while deleting the folder.",
          action: "OK",
          actionCancel: "",
          openDeleteConfirmationDialog: false,
          openSuccessDialogBox: true,
        });
      }
    } catch (error) {
      // console.log("@@Error:", error);
    } finally {
      // setLoadingFolderList(false)
    }
  };

  const handleCloseDialog = () => {
    setDialogState({
      ...dialogState,
      openDeleteConfirmationDialog: false,
      openSuccessDialogBox: false,
    });
    setSelectedFolder(null);
  };
  const handleCloseFolderDialog = () => {
    setDialogForm({
      title: "",
      action: "",
      actionCancel: "",
      data: null,
      openDialogCreate: false,
      openDialogRename: false,
    });
  };

  const handleAddNewFolder = () => {
    // console.log("handleCAddNewFolder");
    setDialogForm({
      title: "Create Folder",
      action: "Create",
      actionCancel: "Cancel",
      data: null,
      openDialogCreate: true,
      openDialogRename: false,
    });
  };
  const handleRenameFolder = (folder: FolderList) => {
    setDialogForm({
      title: "Rename Folder",
      action: "Rename",
      actionCancel: "Cancel",
      data: folder,
      openDialogCreate: false,
      openDialogRename: true,
    });
  };

  const handleDeleteClick = (item: any) => {
    // console.log("handleDeleteClick item", item);
    setFolderDetails(item);
    setDialogState({
      title: "Confirm",
      body: `Are you sure you want to delete <strong>${item.folderName}</strong>`,
      action: "OK",
      actionCancel: "CANCEL",
      openDeleteConfirmationDialog: true,
      openSuccessDialogBox: false,
    });
  };

  const handleAddFolderConfirmed = (folderName: string) => {
    handleCloseFolderDialog();
    setLoadingFolderList(true);
    // console.log("handleAddFolderConfirmed folderName", folderName);
    let payload = {
      folderName: folderName,
      description: folderName,
      companyProfileID: companyProfileID,
      createDate: new Date(),
      createdBy: userId,
    };
    handleCreateFolder(payload);
  };
  const handleRenameConfirmed = (folderName: string, folderData?: FolderList | null) => {
    setLoadingFolderList(true);
    const date = new Date();
    const payload: EditFolderTypes = {
      folderName: folderName,
      description: folderName,
      folderId: folderData?.folderId || 0,
      parentFolderId: folderData?.parentFolderId || null,
      updateDate: date,
      updateBy: userId
    }
    handleRenameFolderAPI(payload)
    handleCloseFolderDialog();
  };

  const handleDeleteConfirmed = () => {
    // console.log("handleRenameConfirmed", "folderName", folderDetails);
    handleCloseDialog();
    setLoadingFolderList(true);
    handleDeleteFolder(folderDetails);
  };

  const handelFolderChange = (item: FolderList) => {
    // console.log("handelFolderChange", "item", item);
    setSelectedFolder(item);
  };

  const handleToggle = (folderId: number) => {
    let openListItem = openedListItems.includes(folderId)
      ? openedListItems.filter((id) => id !== folderId)
      : [...openedListItems, folderId];
    setOpenedListItems(openListItem);
  };

  const FolderItem = ({ folder }) => {
    const handleClick = () => {
      handleToggle(folder.folderId);
      handelFolderChange(folder);
    };

    return (
      <ListItem disableGutters key={folder.folderId} sx={{ display: "flex", flexDirection: "column" }}>
        <Grid
          container
          flexGrow={1}
          spacing={1}
          alignItems="center"
          width="100%"
          style={{
            backgroundColor:
              selectedFolder?.folderId === folder.folderId ? "#cce1ff" : "transparent",
          }}
        >
          <Grid xs={8}>
            <ListItemButton onClick={handleClick} sx={{ p: 0 }}>
              <div style={{ width: "1.5rem" }}>
                {folder.subFolders.length > 0 ? (
                  openedListItems.includes(folder.folderId) ? (
                    <ExpandLess />
                  ) : (
                    <ExpandMore />
                  )
                ) : null}
              </div>
              <ListItemIcon>
                <FolderIcon color="primary" />
              </ListItemIcon>

              {/* Tooltip for ListItemText */}
              <Tooltip title={folder.folderName} disableHoverListener={folder.folderName.length <= 20}>
                <ListItemText
                  primary={folder.folderName}
                  primaryTypographyProps={{
                    noWrap: true,
                    sx: { textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" },
                  }}
                />
              </Tooltip>
            </ListItemButton>
          </Grid>

          <Grid width="3rem">
            <ListItemButton
              sx={{
                "&:hover": {
                  bgcolor: "#E5F0FF",
                },
                borderRadius: "8px",
                justifyContent: "center",
              }}
              disabled={!fileRepoAccess?.isDelete || folder.isFilesAvailable}
              onClick={() => handleDeleteClick(folder)}
            >
              <ListItemIcon sx={{ justifyContent: "center" }}>
                {React.createElement(DeleteFolderIcon)}
              </ListItemIcon>
            </ListItemButton>
          </Grid>

          <Grid width="3rem">
            <ListItemButton
              onClick={() => handleRenameFolder(folder)}
              sx={{
                "&:hover": {
                  bgcolor: "#E5F0FF",
                },
                borderRadius: "8px",
                justifyContent: "center",
              }}
              disabled={!fileRepoAccess?.isUpdate}
            >
              <ListItemIcon sx={{ justifyContent: "center" }}>
                {React.createElement(RenameFolderIcon)}
              </ListItemIcon>
            </ListItemButton>
          </Grid>
        </Grid>

        {folder.subFolders.length > 0 && (
          <Collapse
            in={openedListItems.includes(folder.folderId)}
            timeout="auto"
            unmountOnExit
            sx={{ width: "100%" }}
          >
            <List component="div" disablePadding style={{ marginLeft: "1rem" }}>
              {folder.subFolders.map((subFolder: any) => (
                <FolderItem key={subFolder.folderId} folder={subFolder} />
              ))}
            </List>
          </Collapse>
        )}
      </ListItem>
    );
  };

  useEffect(() => {
    if (!hasFetched.current) {
      handleFetchFolderList();
      hasFetched.current = true;
    }
    // console.log("hasFetched", hasFetched)
  }, []);

  useEffect(() => {
    if (!loadingFolderList) {
      if (folderList && folderList.length > 0) {
        setLoadingFolderList(false);
      }
    }
  }, [folderList, loadingFolderList]);

  useEffect(() => {
    if (refreshFolderList) {
      handleFetchFolderList();
      setLoadingFolderList(true);
    }
  }, [refreshFolderList]);

  return (
    <React.Fragment>
      <Card sx={{ width: "100%", height: "100%", borderRadius: "10px" }}>
        <CardContent>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6">Folder</Typography>
            <Button
              onClick={handleAddNewFolder}
              disabled={!fileRepoAccess?.isCreate || loadingFolderList}
              variant="contained"
              sx={{
                backgroundColor: "#0066FF1A",
                color: "#0066FF",
                "&:hover": {
                  bgcolor: "#0066FF1A",
                  "& .MuiSvgIcon-root": {
                    color: "white",
                  },
                  "& .MuiTypography-root": {
                    color: "white",
                  },
                },
                bgcolor: "#0066FF1A",
                boxShadow: 0,
              }}
              size="small"
            >
              Add New Folder
            </Button>
          </Stack>
        </CardContent>
        <CardContent sx={{ padding: 0, height: 417 }}>
          <List
            sx={{
              width: "100%",
              bgcolor: "background.paper",
              overflow: "auto",
              paddingY: "2px",

              flexGrow: 1,
              maxHeight: "100%",
              // Ensure it doesn't overflow
              "&::-webkit-scrollbar": {
                width: "10px",
                height: "10px",
              },
              "&::-webkit-scrollbar-track": {
                background: "##FFFFFF",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#888",
                borderRadius: "10px",
                border: "2px solid #f1f1f1",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: "#555",
              },
            }}
          >
            {loadingFolderList ? (
              <ListItem
                sx={{ width: "100%", display: "flex", flexDirection: "column" }}
              >
                <CircularProgress />
              </ListItem>

            ) : folderList !== null && folderList.length > 0 ? (
              folderList.map((folder) => (
                <FolderItem key={folder.folderId} folder={folder} />
              ))
            ) : (
              <ListItem>
                <ListItemText
                  sx={{ opacity: 0.7, fontWeight: 400, fontStyle: "italic" }}
                >
                  No folders available.Please create a folder..
                </ListItemText>
              </ListItem>
            )}
          </List>
        </CardContent>
      </Card>
      {
        //Create new folder
        <DialogBoxForm
          openDialogBox={dialogForm.openDialogCreate}
          dialogTitle={dialogForm.title}
          dialogAction={dialogForm.action}
          dialogActionCancel={dialogForm.actionCancel}
          handleFunction={handleAddFolderConfirmed}
          handleCancel={handleCloseFolderDialog}
        />
      }
      {
        //Rename folder
        <DialogBoxForm
          openDialogBox={dialogForm.openDialogRename}
          dialogTitle={dialogForm.title}
          dialogAction={dialogForm.action}
          dialogBody={dialogForm.data}
          dialogActionCancel={dialogForm.actionCancel}
          handleFunction={handleRenameConfirmed}
          handleCancel={handleCloseFolderDialog}
        />
      }
      {
        //Success Dialog
        <DialogBoxComponent
          openDialogBox={dialogState.openSuccessDialogBox}
          dialogTitle={dialogState.title}
          dialogBody={dialogState.body}
          dialogAction={dialogState.action}
          dialogActionCancel={dialogState.actionCancel}
          handleFunction={handleCloseDialog}
        //handleCancel={handleCloseFolderDialog}
        />
      }
      {
        //Delete Conformation
        <DialogBoxComponent
          openDialogBox={dialogState.openDeleteConfirmationDialog}
          dialogTitle={dialogState.title}
          dialogBody={dialogState.body}
          dialogAction={dialogState.action}
          dialogActionCancel={dialogState.actionCancel}
          handleFunction={handleDeleteConfirmed}
          handleCancel={handleCloseDialog}
        />
      }
    </React.Fragment>
  );
};
